import * as React from 'react';

import { Alert } from 'antd';

function DateLimitAlert() {
  return (
    <>
      <Alert
        type='info'
        message={
          <>
            O acesso a Documentos Fiscais da aba Notas a Clientes a partir de <strong> 01/04/2023 </strong> deve ser
            acessado no{' '}
            <a href='https://my2.eduzz.com/docs-fiscais' target='_blank' rel='noopener noreferrer'>
              novo serviço!
            </a>
          </>
        }
      />
    </>
  );
}

export { DateLimitAlert };
